var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{ref:"upload",staticClass:"upload-demo inline-block margin-right-10",staticStyle:{"margin-left":"8px"},attrs:{"action":"","on-change":_vm.handleChange,"show-file-list":false,"accept":".csv, .xlsx, .xls","auto-upload":false,"disabled":!_vm.isCustomSetting}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }